<app-custom-breadcrumb [crumbs]="breadcrumbs"></app-custom-breadcrumb>
<div class="my-3">
  <h2>Add Inspection Record</h2>
</div>

<div [ngClass]="!loading ? 'block' : 'hidden'">
  <section id="inspectDetails">
    <nz-card>
      <div>
        <h5 class="text-primary">Inspection Details</h5>
        <div class="mt-5 grid md:grid-cols-1 xl:grid-cols-2 gap-8">

          <div>

            <form nz-form [formGroup]="inspectionForm">

              <div class="grid sm:grid-cols-2 gap-3" formGroupName="inspectionDetails">

                <nz-form-item class="grid grid-flow-row content-start">
                  <nz-form-label nzFor="reason">Reason for the inspection</nz-form-label>
                  <nz-form-control [nzErrorTip]="reasonError">
                    <nz-select formControlName="reason" [(ngModel)]="this.reason"
                               (ngModelChange)="getBookingsByFleet($event)"
                               [nzDisabled]="this.parameter !== 'Before'" nzPlaceHolder="Select Reason">
                      <nz-option nzLabel="Rent Booking" nzValue="Rent"></nz-option>
                      <nz-option nzLabel="Transfer Booking" nzValue="Transfer"></nz-option>
                      <nz-option nzLabel="Other Booking" nzValue="Office Use"></nz-option>
                      <nz-option nzLabel="Other Reason" nzValue="Other"></nz-option>
                      <nz-option *ngIf="this.reason==='Initial'" nzLabel="Initial" nzValue="Initial"></nz-option>
                      <nz-option *ngIf="this.reason==='Final'" nzLabel="Final" nzValue="Final"></nz-option>
                    </nz-select>
                  </nz-form-control>
                  <ng-template #reasonError>
                    <span *ngIf="formErrors.inspectionDetails.reason.required">Please select Reason </span>
                  </ng-template>
                </nz-form-item>

                <div class="lg:col-span-2"
                     *ngIf="inspectionForm.get('inspectionDetails.reason').value === 'Rent' || inspectionForm.get('inspectionDetails.reason').value === 'Transfer' || inspectionForm.get('inspectionDetails.reason').value === 'Office Use'"
                     formGroupName="bookingDetails">
                  <nz-form-item class="grid grid-flow-row content-start">
                    <nz-form-label nzRequired>Booking</nz-form-label>
                    <nz-form-control [nzErrorTip]="bookingError">
                      <nz-select class="w-full" formControlName="booking" nzShowSearch nzAllowClear
                                 (ngModelChange)="setBookingDetails($event)" [nzDisabled]="this.parameter === 'After'"
                                 nzPlaceHolder="Select Booking">
                        <nz-option *ngFor="let op of bookingOptions" nzValue="{{op?._id}}"
                                   nzLabel="{{op?.refNo}} | {{op?.customerName ? op?.customerName : ''}}
                             | From {{op.arrivalDate | date: 'yyyy-MM-dd'}} to {{op.departureDate | date: 'yyyy-MM-dd'}}
                             | {{op?.type}}"></nz-option>
                      </nz-select>
                      <p class="text-sm text-primary" *ngIf="fleetBookingsLoading">Loading...</p>
                    </nz-form-control>
                    <ng-template #bookingError>
                    <span
                      *ngIf="formErrors?.bookingDetails?.booking?.required">Please select the relevant booking</span>
                    </ng-template>
                  </nz-form-item>
                </div>

                <nz-form-item class="grid grid-flow-row content-start"
                              *ngIf="this.inspectionForm.get('inspectionDetails.reason').value === 'Other'">
                  <nz-form-label nzFor="otherReason">Other Reasons</nz-form-label>
                  <nz-form-control [nzErrorTip]="otherReasonError">
                    <input nz-input type="text" formControlName="otherReason" [disabled]="this.parameter !== 'Before'"
                           nzPlaceHolder="Enter Reason for this inspection"/>
                  </nz-form-control>
                  <ng-template #otherReasonError>
                    <span
                      *ngIf="inspectionForm.get('reason').value === 'Other' && inspectionForm.get('otherReason').hasError('required')">Please
                      enter a reason. </span>
                  </ng-template>
                </nz-form-item>

                <nz-form-item class="grid grid-flow-row content-start">
                  <nz-form-label nzFor="Odometer">Odometer</nz-form-label>
                  <nz-form-control [nzErrorTip]="odometerError">
                    <nz-input-group nzAddOnAfter="Km">
                      <input nz-input type="number" [min]="0" [step]="1" formControlName="Odometer" placeholder="Enter Odometer"/>
                    </nz-input-group>
<!--                    <nz-input-number class="w-full" formControlName="Odometer" nzPlaceHolder="Enter Odometer"-->
<!--                                     [nzMin]="0" [nzStep]="1" [nzFormatter]="formatterDistance"-->
<!--                                     [nzParser]="parserDistance"></nz-input-number>-->
                  </nz-form-control>
                  <ng-template #odometerError>
                    <span *ngIf="formErrors.inspectionDetails.odometer.required">Please enter Odometer</span>
                  </ng-template>
                </nz-form-item>

                <nz-form-item class="grid grid-flow-row content-start">
                  <nz-form-label nzFor="fuelLevel">Fuel Level</nz-form-label>
                  <nz-form-control>
                    <nz-input-group nzAddOnAfter="%">
                      <input nz-input type="number" [min]="0" [max]="100" [step]="1" formControlName="fuelLevel" placeholder="Enter Fuel level"/>
                    </nz-input-group>
<!--                    <nz-input-number class="w-full" formControlName="fuelLevel" nzPlaceHolder="Enter Fuel level"-->
<!--                                     [nzMin]="0" [nzMax]="100" [nzStep]="1" [nzFormatter]="formatterPercentFuel"-->
<!--                                     [nzParser]="parserPercentFuel"></nz-input-number>-->
                  </nz-form-control>
                  <!--                <ng-template #fuelLevelError>-->
                  <!--                  <span *ngIf="formErrors.inspectionDetails.fuelLevel.required">Please enter Fuel level</span>-->
                  <!--                </ng-template>-->
                </nz-form-item>
              </div>
            </form>
          </div>

          <div>
            <div class="sub-section" style="height: 100%">
              <div class="item-row">
                <!--                <p class="subject-name">Booking Reference</p>-->
                <!--                <p class="subject-data">123456789</p>-->
              </div>
              <div class="item-row">
                <p class="subject-name">Date</p>
                <p class="subject-data">{{ this.formattedDate }}</p>
              </div>
              <div class="item-row">
                <p class="subject-name">Model</p>
                <p class="subject-data">{{ this.fleetData.vehicleDetails.vehicleModel }}</p>
              </div>
              <div class="item-row">
                <p class="subject-name">Registration Number</p>
                <p class="subject-data">{{ this.fleetData.vehicleDetails.registrationNumber }}</p>
              </div>
              <div class="item-row">
                <p class="subject-name">Form Version</p>
                <p class="subject-data">{{ this.parameter }}</p>
              </div>
              <h5 class="text-primary mt-3 mb-2" *ngIf="selectedBooking">Booking Details</h5>
              <div class="item-row" *ngIf="selectedBooking">
                <p class="subject-name">SR Booking Id:</p>
                <p class="subject-data">{{ selectedBooking?.refNo ? selectedBooking?.refNo : '-' }}</p>
              </div>
              <div class="item-row" *ngIf="selectedBooking">
                <p class="subject-name">Booking Type:</p>
                <p class="subject-data">{{ selectedBooking?.type ? selectedBooking?.type : '-' }}</p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </nz-card>
  </section>


  <section id="recordInfo" class="mt-8">
    <nz-card>
      <div>
        <h5 class="text-primary">Record Information</h5>
        <nz-divider></nz-divider>
        <div>
          <div class="mt-5 grid md:grid-cols-1 xl:grid-cols-2 gap-8">
            <form nz-form [formGroup]="inspectionForm">

              <div class="flex items-center" *ngIf="parameter==='After' || this.parameter==='Final'">
                <label class="w-2/4"></label>
                <label class="w-1/4 font-semibold">Before</label>
                <label class="w-1/4 font-semibold">After</label>
              </div>


              <div class="flex items-center">
                <label class="w-2/4">Dashboard</label>
                <div class="w-1/4" formGroupName="beforeInfo">
                  <nz-form-item>
                    <nz-form-control *ngIf="parameter==='After' || this.parameter==='Final'">
                      <label style="margin-left: 7px" nz-checkbox nzDisabled formControlName="dashboard"></label>
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div class="w-1/4" formGroupName="recordInformation">
                  <nz-form-item>
                    <nz-form-control>
                      <label style="margin-left: 7px" nz-checkbox formControlName="dashboard"></label>
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div>

              <div class="flex items-center">
                <label class="w-2/4">Left Mirror</label>
                <div class="w-1/4" formGroupName="beforeInfo">
                  <nz-form-item>
                    <nz-form-control *ngIf="parameter==='After' || this.parameter==='Final'">
                      <label nz-checkbox style="margin-left: 7px" nzDisabled formControlName="leftMirror"></label>
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div class="w-1/4" formGroupName="recordInformation">
                  <nz-form-item>
                    <nz-form-control>
                      <label nz-checkbox style="margin-left: 7px" formControlName="leftMirror"></label>
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div>

              <div class="flex items-center">
                <label class="w-2/4">Right Mirror</label>
                <div class="w-1/4" formGroupName="beforeInfo">
                  <nz-form-item>
                    <nz-form-control *ngIf="parameter==='After' || this.parameter==='Final'">
                      <label nz-checkbox style="margin-left: 7px" nzDisabled formControlName="rightMirror"></label>
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div class="w-1/4" formGroupName="recordInformation">
                  <nz-form-item>
                    <nz-form-control>
                      <label nz-checkbox style="margin-left: 7px" formControlName="rightMirror"></label>
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div>

              <div class="flex items-center">
                <label class="w-2/4">Lighter</label>
                <div class="w-1/4" formGroupName="beforeInfo">
                  <nz-form-item>
                    <nz-form-control *ngIf="parameter==='After' || this.parameter==='Final'">
                      <label nz-checkbox style="margin-left: 7px" nzDisabled formControlName="lighter"></label>
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div class="w-1/4" formGroupName="recordInformation">
                  <nz-form-item>
                    <nz-form-control>
                      <label nz-checkbox style="margin-left: 7px" formControlName="lighter"></label>
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div>

              <div class="flex items-center">
                <label class="w-2/4">Reverse Camera</label>
                <div class="w-1/4" formGroupName="beforeInfo">
                  <nz-form-item>
                    <nz-form-control *ngIf="parameter==='After' || this.parameter==='Final'">
                      <label nz-checkbox style="margin-left: 7px" nzDisabled formControlName="reverseCam"></label>
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div class="w-1/4" formGroupName="recordInformation">
                  <nz-form-item>
                    <nz-form-control>
                      <label nz-checkbox style="margin-left: 7px" formControlName="reverseCam"></label>
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div>

              <div class="flex items-center">
                <label class="w-2/4">Sensors</label>
                <div class="w-1/4" formGroupName="beforeInfo">
                  <nz-form-item>
                    <nz-form-control *ngIf="parameter==='After' || this.parameter==='Final'">
                      <label nz-checkbox style="margin-left: 7px" nzDisabled formControlName="sensors"></label>
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div class="w-1/4" formGroupName="recordInformation">
                  <nz-form-item>
                    <nz-form-control>
                      <label nz-checkbox style="margin-left: 7px" formControlName="sensors"></label>
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div>

              <div class="flex items-center">
                <label class="w-2/4">Keys</label>
                <div class="w-1/4" formGroupName="beforeInfo">
                  <nz-form-item>
                    <nz-form-control *ngIf="parameter==='After' || this.parameter==='Final'">
                      <label nz-checkbox style="margin-left: 7px" nzDisabled formControlName="keys"></label>
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div class="w-1/4" formGroupName="recordInformation">
                  <nz-form-item>
                    <nz-form-control>
                      <label nz-checkbox style="margin-left: 7px" formControlName="keys"></label>
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div>

              <div class="flex items-center">
                <label class="w-2/4">Radio</label>
                <div class="w-1/4" formGroupName="beforeInfo">
                  <nz-form-item>
                    <nz-form-control *ngIf="parameter==='After' || this.parameter==='Final'">
                      <label nz-checkbox style="margin-left: 7px" nzDisabled formControlName="radio"></label>
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div class="w-1/4" formGroupName="recordInformation">
                  <nz-form-item>
                    <nz-form-control>
                      <label nz-checkbox style="margin-left: 7px" formControlName="radio"></label>
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div>

              <div class="flex items-center">
                <label class="w-2/4">Bluetooth</label>
                <div class="w-1/4" formGroupName="beforeInfo">
                  <nz-form-item>
                    <nz-form-control *ngIf="parameter==='After' || this.parameter==='Final'">
                      <label nz-checkbox style="margin-left: 7px" nzDisabled formControlName="bluetooth"></label>
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div class="w-1/4" formGroupName="recordInformation">
                  <nz-form-item>
                    <nz-form-control>
                      <label nz-checkbox style="margin-left: 7px" formControlName="bluetooth"></label>
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div>

              <div class="flex items-center">
                <label class="w-2/4">A/C</label>
                <div class="w-1/4" formGroupName="beforeInfo">
                  <nz-form-item>
                    <nz-form-control *ngIf="parameter==='After' || this.parameter==='Final'">
                      <label nz-checkbox style="margin-left: 7px" nzDisabled formControlName="ac"></label>
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div class="w-1/4" formGroupName="recordInformation">
                  <nz-form-item>
                    <nz-form-control>
                      <label nz-checkbox style="margin-left: 7px" formControlName="ac"></label>
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div>

              <div class="flex items-center">
                <label class="w-2/4">License, Insurance, Eco Test</label>
                <div class="w-1/4" formGroupName="beforeInfo">
                  <nz-form-item>
                    <nz-form-control *ngIf="parameter==='After' || this.parameter==='Final'">
                      <label nz-checkbox style="margin-left: 7px" nzDisabled
                             formControlName="LicenceInsuranceEco"></label>
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div class="w-1/4" formGroupName="recordInformation">
                  <nz-form-item>
                    <nz-form-control>
                      <label nz-checkbox style="margin-left: 7px" formControlName="LicenceInsuranceEco"></label>
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div>

              <div class="flex items-center">
                <label class="w-2/4">Sun Shades</label>
                <div class="w-1/4" formGroupName="beforeInfo">
                  <nz-form-item>
                    <nz-form-control *ngIf="parameter==='After' || this.parameter==='Final'">
                      <label nz-checkbox style="margin-left: 7px" nzDisabled formControlName="sunShades"></label>
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div class="w-1/4" formGroupName="recordInformation">
                  <nz-form-item>
                    <nz-form-control>
                      <label nz-checkbox style="margin-left: 7px" formControlName="sunShades"></label>
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div>

              <div class="flex items-center">
                <label class="w-2/4">Wiper Blades</label>
                <div class="w-1/4" formGroupName="beforeInfo">
                  <nz-form-item>
                    <nz-form-control *ngIf="parameter==='After' || this.parameter==='Final'">
                      <label nz-checkbox style="margin-left: 7px" nzDisabled formControlName="wiperBlades"></label>
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div class="w-1/4" formGroupName="recordInformation">
                  <nz-form-item>
                    <nz-form-control>
                      <label nz-checkbox style="margin-left: 7px" formControlName="wiperBlades"></label>
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div>

              <div class="flex items-center">
                <label class="w-2/4">Horn</label>
                <div class="w-1/4" formGroupName="beforeInfo">
                  <nz-form-item>
                    <nz-form-control *ngIf="parameter==='After' || this.parameter==='Final'">
                      <label nz-checkbox style="margin-left: 7px" nzDisabled formControlName="horn"></label>
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div class="w-1/4" formGroupName="recordInformation">
                  <nz-form-item>
                    <nz-form-control>
                      <label nz-checkbox style="margin-left: 7px" formControlName="horn"></label>
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div>

              <div class="flex items-center">
                <label class="w-2/4">L-Front Light</label>
                <div class="w-1/4" formGroupName="beforeInfo">
                  <nz-form-item>
                    <nz-form-control *ngIf="parameter==='After' || this.parameter==='Final'">
                      <label nz-checkbox style="margin-left: 7px" nzDisabled formControlName="lFrontLight"></label>
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div class="w-1/4" formGroupName="recordInformation">
                  <nz-form-item>
                    <nz-form-control>
                      <label nz-checkbox style="margin-left: 7px" formControlName="lFrontLight"></label>
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div>

              <div class="flex items-center">
                <label class="w-2/4">R-Front Light</label>
                <div class="w-1/4" formGroupName="beforeInfo">
                  <nz-form-item>
                    <nz-form-control *ngIf="parameter==='After' || this.parameter==='Final'">
                      <label nz-checkbox style="margin-left: 7px" nzDisabled formControlName="rFrontLight"></label>
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div class="w-1/4" formGroupName="recordInformation">
                  <nz-form-item>
                    <nz-form-control>
                      <label nz-checkbox style="margin-left: 7px" formControlName="rFrontLight"></label>
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div>

              <div class="flex items-center">
                <label class="w-2/4">L-Head Light</label>
                <div class="w-1/4" formGroupName="beforeInfo">
                  <nz-form-item>
                    <nz-form-control *ngIf="parameter==='After' || this.parameter==='Final'">
                      <label nz-checkbox style="margin-left: 7px" nzDisabled formControlName="lHeadLight"></label>
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div class="w-1/4" formGroupName="recordInformation">
                  <nz-form-item>
                    <nz-form-control>
                      <label nz-checkbox style="margin-left: 7px" formControlName="lHeadLight"></label>
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div>

              <div class="flex items-center">
                <label class="w-2/4">R-Head Light</label>
                <div class="w-1/4" formGroupName="beforeInfo">
                  <nz-form-item>
                    <nz-form-control *ngIf="parameter==='After' || this.parameter==='Final'">
                      <label nz-checkbox style="margin-left: 7px" nzDisabled formControlName="rHeadLight"></label>
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div class="w-1/4" formGroupName="recordInformation">
                  <nz-form-item>
                    <nz-form-control>
                      <label nz-checkbox style="margin-left: 7px" formControlName="rHeadLight"></label>
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div>

              <div class="flex items-center">
                <label class="w-2/4">L-Fog Light</label>
                <div class="w-1/4" formGroupName="beforeInfo">
                  <nz-form-item>
                    <nz-form-control *ngIf="parameter==='After' || this.parameter==='Final'">
                      <label nz-checkbox style="margin-left: 7px" nzDisabled formControlName="lFogLight"></label>
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div class="w-1/4" formGroupName="recordInformation">
                  <nz-form-item>
                    <nz-form-control>
                      <label nz-checkbox style="margin-left: 7px" formControlName="lFogLight"></label>
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div>

              <div class="flex items-center">
                <label class="w-2/4">R-Fog Light</label>
                <div class="w-1/4" formGroupName="beforeInfo">
                  <nz-form-item>
                    <nz-form-control *ngIf="parameter==='After' || this.parameter==='Final'">
                      <label nz-checkbox style="margin-left: 7px" nzDisabled formControlName="rFogLight"></label>
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div class="w-1/4" formGroupName="recordInformation">
                  <nz-form-item>
                    <nz-form-control>
                      <label nz-checkbox style="margin-left: 7px" formControlName="rFogLight"></label>
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div>

              <div class="flex items-center">
                <label class="w-2/4">Other Tool Kit</label>
                <div class="w-1/4" formGroupName="beforeInfo">
                  <nz-form-item>
                    <nz-form-control *ngIf="parameter==='After' || this.parameter==='Final'">
                      <label nz-checkbox style="margin-left: 7px" nzDisabled formControlName="otherToolKit"></label>
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div class="w-1/4" formGroupName="recordInformation">
                  <nz-form-item>
                    <nz-form-control>
                      <label nz-checkbox style="margin-left: 7px" formControlName="otherToolKit"></label>
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div>

              <div class="flex items-center">
                <label class="w-2/4">L-Signal Light</label>
                <div class="w-1/4" formGroupName="beforeInfo">
                  <nz-form-item>
                    <nz-form-control *ngIf="parameter==='After' || this.parameter==='Final'">
                      <label nz-checkbox style="margin-left: 7px" nzDisabled formControlName="lSignalLight"></label>
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div class="w-1/4" formGroupName="recordInformation">
                  <nz-form-item>
                    <nz-form-control>
                      <label nz-checkbox style="margin-left: 7px" formControlName="lSignalLight"></label>
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div>

              <div class="flex items-center">
                <label class="w-2/4">R-Signal Light</label>
                <div class="w-1/4" formGroupName="beforeInfo">
                  <nz-form-item>
                    <nz-form-control *ngIf="parameter==='After' || this.parameter==='Final'">
                      <label nz-checkbox style="margin-left: 7px" nzDisabled formControlName="rSignalLight"></label>
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div class="w-1/4" formGroupName="recordInformation">
                  <nz-form-item>
                    <nz-form-control>
                      <label nz-checkbox style="margin-left: 7px" formControlName="rSignalLight"></label>
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div>

              <div class="flex items-center">
                <label class="w-2/4">L-Winker</label>
                <div class="w-1/4" formGroupName="beforeInfo">
                  <nz-form-item>
                    <nz-form-control *ngIf="parameter==='After' || this.parameter==='Final'">
                      <label nz-checkbox style="margin-left: 7px" nzDisabled formControlName="lWinker"></label>
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div class="w-1/4" formGroupName="recordInformation">
                  <nz-form-item>
                    <nz-form-control>
                      <label nz-checkbox style="margin-left: 7px" formControlName="lWinker"></label>
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div>

              <div class="flex items-center">
                <label class="w-2/4">R-Winker</label>
                <div class="w-1/4" formGroupName="beforeInfo">
                  <nz-form-item>
                    <nz-form-control *ngIf="parameter==='After' || this.parameter==='Final'">
                      <label nz-checkbox style="margin-left: 7px" nzDisabled formControlName="rWinker"></label>
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div class="w-1/4" formGroupName="recordInformation">
                  <nz-form-item>
                    <nz-form-control>
                      <label nz-checkbox style="margin-left: 7px" formControlName="rWinker"></label>
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div>

              <div class="flex items-center">
                <label class="w-2/4">L-Rear Light</label>
                <div class="w-1/4" formGroupName="beforeInfo">
                  <nz-form-item>
                    <nz-form-control *ngIf="parameter==='After' || this.parameter==='Final'">
                      <label nz-checkbox style="margin-left: 7px" nzDisabled formControlName="lRearLight"></label>
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div class="w-1/4" formGroupName="recordInformation">
                  <nz-form-item>
                    <nz-form-control>
                      <label nz-checkbox style="margin-left: 7px" formControlName="lRearLight"></label>
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div>

              <div class="flex items-center">
                <label class="w-2/4">R-Rear Light</label>
                <div class="w-1/4" formGroupName="beforeInfo">
                  <nz-form-item>
                    <nz-form-control *ngIf="parameter==='After' || this.parameter==='Final'">
                      <label nz-checkbox style="margin-left: 7px" nzDisabled formControlName="rRearLight"></label>
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div class="w-1/4" formGroupName="recordInformation">
                  <nz-form-item>
                    <nz-form-control>
                      <label nz-checkbox style="margin-left: 7px" formControlName="rRearLight"></label>
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div>

              <div class="flex items-center">
                <label class="w-2/4">L-Break Light</label>
                <div class="w-1/4" formGroupName="beforeInfo">
                  <nz-form-item>
                    <nz-form-control *ngIf="parameter==='After' || this.parameter==='Final'">
                      <label nz-checkbox style="margin-left: 7px" nzDisabled formControlName="lBreakLight"></label>
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div class="w-1/4" formGroupName="recordInformation">
                  <nz-form-item>
                    <nz-form-control>
                      <label nz-checkbox style="margin-left: 7px" formControlName="lBreakLight"></label>
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div>

              <div class="flex items-center">
                <label class="w-2/4">R-Break Light</label>
                <div class="w-1/4" formGroupName="beforeInfo">
                  <nz-form-item>
                    <nz-form-control *ngIf="parameter==='After' || this.parameter==='Final'">
                      <label nz-checkbox style="margin-left: 7px" nzDisabled formControlName="rBreakLight"></label>
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div class="w-1/4" formGroupName="recordInformation">
                  <nz-form-item>
                    <nz-form-control>
                      <label nz-checkbox style="margin-left: 7px" formControlName="rBreakLight"></label>
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div>

              <div class="flex items-center">
                <label class="w-2/4">Rear Roof Light</label>
                <div class="w-1/4" formGroupName="beforeInfo">
                  <nz-form-item>
                    <nz-form-control *ngIf="parameter==='After' || this.parameter==='Final'">
                      <label nz-checkbox style="margin-left: 7px" nzDisabled formControlName="RearRoofLight"></label>
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div class="w-1/4" formGroupName="recordInformation">
                  <nz-form-item>
                    <nz-form-control>
                      <label nz-checkbox style="margin-left: 7px" formControlName="RearRoofLight"></label>
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div>

              <div class="flex items-center">
                <label class="w-2/4">Original Carpets</label>
                <div class="w-1/4" formGroupName="beforeInfo">
                  <nz-form-item>
                    <nz-form-control *ngIf="parameter==='After' || this.parameter==='Final'">
                      <label nz-checkbox style="margin-left: 7px" nzDisabled formControlName="originalCarpets"></label>
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div class="w-1/4" formGroupName="recordInformation">
                  <nz-form-item>
                    <nz-form-control>
                      <label nz-checkbox style="margin-left: 7px" formControlName="originalCarpets"></label>
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div>

              <div class="flex items-center">
                <label class="w-2/4">3M Carpets</label>
                <div class="w-1/4" formGroupName="beforeInfo">
                  <nz-form-item>
                    <nz-form-control *ngIf="parameter==='After' || this.parameter==='Final'">
                      <label nz-checkbox style="margin-left: 7px" nzDisabled formControlName="mCarpets"></label>
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div class="w-1/4" formGroupName="recordInformation">
                  <nz-form-item>
                    <nz-form-control>
                      <label nz-checkbox style="margin-left: 7px" formControlName="mCarpets"></label>
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div>

              <div class="flex items-center">
                <label class="w-2/4">Wheel Caps</label>
                <div class="w-1/4" formGroupName="beforeInfo">
                  <nz-form-item>
                    <nz-form-control *ngIf="parameter==='After' || this.parameter==='Final'">
                      <label nz-checkbox style="margin-left: 7px" nzDisabled formControlName="wheelCaps"></label>
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div class="w-1/4" formGroupName="recordInformation">
                  <nz-form-item>
                    <nz-form-control>
                      <label nz-checkbox style="margin-left: 7px" formControlName="wheelCaps"></label>
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div>


              <div class="flex items-center">
                <label class="w-2/4">Hub Caps</label>
                <div class="w-1/4" formGroupName="beforeInfo">
                  <nz-form-item>
                    <nz-form-control *ngIf="parameter==='After' || this.parameter==='Final'">
                      <label nz-checkbox style="margin-left: 7px" nzDisabled formControlName="hubCaps"></label>
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div class="w-1/4" formGroupName="recordInformation">
                  <nz-form-item>
                    <nz-form-control>
                      <label nz-checkbox style="margin-left: 7px" formControlName="hubCaps"></label>
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div>

              <div class="flex items-center">
                <label class="w-2/4">Inner Mud Guard</label>
                <div class="w-1/4" formGroupName="beforeInfo">
                  <nz-form-item>
                    <nz-form-control *ngIf="parameter==='After' || this.parameter==='Final'">
                      <label nz-checkbox style="margin-left: 7px" nzDisabled formControlName="innerMudGaurd"></label>
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div class="w-1/4" formGroupName="recordInformation">
                  <nz-form-item>
                    <nz-form-control>
                      <label nz-checkbox style="margin-left: 7px" formControlName="innerMudGaurd"></label>
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div>

              <div class="flex items-center">
                <label class="w-2/4">Badges</label>
                <div class="w-1/4" formGroupName="beforeInfo">
                  <nz-form-item>
                    <nz-form-control *ngIf="parameter==='After' || this.parameter==='Final'">
                      <label nz-checkbox style="margin-left: 7px" nzDisabled formControlName="badges"></label>
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div class="w-1/4" formGroupName="recordInformation">
                  <nz-form-item>
                    <nz-form-control>
                      <label nz-checkbox style="margin-left: 7px" formControlName="badges"></label>
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div>

              <div class="flex items-center">
                <label class="w-2/4">Spare Wheel</label>
                <div class="w-1/4" formGroupName="beforeInfo">
                  <nz-form-item>
                    <nz-form-control *ngIf="parameter==='After' || this.parameter==='Final'">
                      <label nz-checkbox style="margin-left: 7px" nzDisabled formControlName="spareWheel"></label>
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div class="w-1/4" formGroupName="recordInformation">
                  <nz-form-item>
                    <nz-form-control>
                      <label nz-checkbox style="margin-left: 7px" formControlName="spareWheel"></label>
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div>

              <div class="flex items-center">
                <label class="w-2/4">Jack And Handle</label>
                <div class="w-1/4" formGroupName="beforeInfo">
                  <nz-form-item>
                    <nz-form-control *ngIf="parameter==='After' || this.parameter==='Final'">
                      <label nz-checkbox style="margin-left: 7px" nzDisabled formControlName="jackAndHandle"></label>
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div class="w-1/4" formGroupName="recordInformation">
                  <nz-form-item>
                    <nz-form-control>
                      <label nz-checkbox style="margin-left: 7px" formControlName="jackAndHandle"></label>
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div>

              <div class="flex items-center">
                <label class="w-2/4">Wheel Brush</label>
                <div class="w-1/4" formGroupName="beforeInfo">
                  <nz-form-item>
                    <nz-form-control *ngIf="parameter==='After' || this.parameter==='Final'">
                      <label nz-checkbox style="margin-left: 7px" nzDisabled formControlName="wheelBrush"></label>
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div class="w-1/4" formGroupName="recordInformation">
                  <nz-form-item>
                    <nz-form-control>
                      <label nz-checkbox style="margin-left: 7px" formControlName="wheelBrush"></label>
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div>

              <div class="flex items-center">
                <label class="w-2/4">Electric Air Pump</label>
                <div class="w-1/4" formGroupName="beforeInfo">
                  <nz-form-item>
                    <nz-form-control *ngIf="parameter==='After' || this.parameter==='Final'">
                      <label nz-checkbox style="margin-left: 7px" nzDisabled formControlName="electricAirPump"></label>
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div class="w-1/4" formGroupName="recordInformation">
                  <nz-form-item>
                    <nz-form-control>
                      <label nz-checkbox style="margin-left: 7px" formControlName="electricAirPump"></label>
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div>

              <div class="flex items-center">
                <label class="w-2/4">Tyre Glue</label>
                <div class="w-1/4" formGroupName="beforeInfo">
                  <nz-form-item>
                    <nz-form-control *ngIf="parameter==='After' || this.parameter==='Final'">
                      <label nz-checkbox style="margin-left: 7px" nzDisabled formControlName="tyreGlue"></label>
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div class="w-1/4" formGroupName="recordInformation">
                  <nz-form-item>
                    <nz-form-control>
                      <label nz-checkbox style="margin-left: 7px" formControlName="tyreGlue"></label>
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div>

            </form>


            <div class="sub-section overflow-scroll md:overflow-auto" style="height: 100%">
              <div>

                <form nz-form [formGroup]="inspectionForm">
                  <div formGroupName="recordInformation"
                       class="bg-[#fff8f0] rounded-md px-4 py-2 border border-solid border-[#ffca9e] min-w-[300px]">

                    <div class="flex flex-row items-center">
                      <nz-form-item class="ml-2 mt-2">
                        <nz-form-control>
                          <label nz-checkbox nzDisabled formControlName="functioning"></label>
                        </nz-form-control>
                      </nz-form-item>
                      <label class="ml-2">- is Functioning or Available</label>
                    </div>

                    <div class="flex flex-row items-center">
                      <nz-form-item class="ml-2 mt-2">
                        <nz-form-control>
                          <label nz-checkbox nzDisabled formControlName="malfunctioning"></label>
                        </nz-form-control>
                      </nz-form-item>
                      <label class="ml-2">- is Malfunctioning or Unavailable</label>
                    </div>

                  </div>
                </form>
              </div>

            </div>
          </div>
        </div>
      </div>
    </nz-card>
  </section>

  <section id="damages" class="mt-8">
    <nz-card>
      <div>
        <h5 class="text-primary">Damages </h5>
        <div class="mt-5 grid md:grid-cols-1 xl:grid-cols-2 gap-8">
          <div>
            <div class=" md:col-span-2  p-6">
              <nz-alert nzType="info" nzMessage="Select the damaged area on the image below to add a new record"
                        class="mb-3 custom-alert" nzShowIcon></nz-alert>
            </div>

            <div class="image-container cursor-crosshair" (click)="showModal($event)">
              <img style="max-width: 100%;height: auto;" src="assets/img/car-damage.png" alt="Image" #image>
              <div *ngFor="let marker of markers">
                <div *ngIf="marker?.status !== false" class="marker" [style.left.%]="marker.x" [style.top.%]="marker.y">
                  {{ marker.number }}
                </div>
                <!--                <div style="background-color: green" *ngIf="marker.status === false" class="marker"-->
                <!--                     [style.left.%]="marker.x" [style.top.%]="marker.y">-->
                <!--                  {{ marker.number }}-->
                <!--                </div>-->
              </div>
            </div>
          </div>

          <div class="sub-section">


            <nz-collapse>
              <ng-container *ngFor="let panel of markers; let i = index">
              <nz-collapse-panel [nzHeader]='panelHead' *ngIf="panel?.status !== false"
                                 style="background-color: white; border: 2px solid #d9d9d9;" class="font-medium">

                <div class="damage-card mb-3 my-2 flex flex-col sm:flex-row">


                  <div class="w-full p-5">
                    <div class="pl-0 sm:pl-2">
                      <div class="item-row flex mb-2">
                        <div>
                          <p style="font-weight: 400; color: #6d6d6d">Damage Type: </p>
                          <p class="subject-data">{{ panel.damageType }}</p>
                        </div>
                        <div class="flex-grow">

                        </div>
                        <div class="badge-Id">
                          <span class="badge-number" *ngIf="panel.damageType === 'Scratch'">1</span>
                          <span class="badge-number" *ngIf="panel.damageType === 'Dent'">2</span>
                          <span class="badge-number" *ngIf="panel.damageType === 'Broken'">3</span>
                          <span class="badge-number" *ngIf="panel.damageType === 'Cracked'">4</span>
                          <span class="badge-number" *ngIf="panel.damageType === 'Missing'">5</span>
                          <span class="badge-number" *ngIf="panel.damageType === 'Stain'">6</span>
                          <span class="badge-number" *ngIf="panel.damageType === 'Smashed'">7</span>
                        </div>
                      </div>

                      <div class="mb-2">
                        <p class="subject-name">Description: </p>
                        <p class="subject-data">{{ panel.description }}</p>
                      </div>

                      <div class="mb-2">
                        <p class="subject-name">Attachments: </p>
                        <div class="mt-3 flex" style="flex-wrap: wrap;">
                          <img *ngFor="let attachment of panel.files" style="margin-left: 3px; margin-bottom: 3px"
                               [src]="attachment.url" height="80" width="160" alt="Image">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="">
                  <nz-divider></nz-divider>
                </div>

                <ng-template #panelHead>
                  <div class="flex" style="margin-right: 20px">
                    <div class="badge" *ngIf="panel?.status !== false">
                      <span class="badge-number">{{ panel.number }}</span>
                    </div>
                    <div class="badge" style="background-color: green" *ngIf="panel.status === false">
                      <span class="badge-number">{{ panel.number }}</span>
                    </div>
                  </div>
                  <p class="font-semibold">{{ panel.damageType }}</p>
                  <div class="flex-grow"></div><!-- This div will push the button to the right -->
                  <button class="outline-button more-dropdown" nz-button nz-dropdown [nzDropdownMenu]="menu"
                          nzPlacement="bottomCenter" (click)="$event.stopPropagation()">
                    <span nz-icon nzType="more" nzTheme="outline"></span>
                  </button>
                  <nz-dropdown-menu #menu="nzDropdownMenu">
                    <ul nz-menu>
                      <li nz-menu-item (click)="showModal2(panel)" *ngIf="(this.parameter !== 'Initial')">Fixed
                      </li>
                      <li nz-menu-item nz-popconfirm nz-button (click)="editDamage(panel)" *ngIf="(this.parameter !== 'After')">Edit</li>
                      <li nz-menu-item nz-button nzDanger nz-popconfirm
                          nzPopconfirmTitle="Are you sure you want to delete the Damage Record"
                          nzPopconfirmPlacement="bottom" (nzOnConfirm)="deleteRecord(i)" (nzOnCancel)="cancel()" *ngIf="(this.parameter !== 'After')">Delete
                      </li>
                    </ul>
                  </nz-dropdown-menu>
                </ng-template>
              </nz-collapse-panel>
              </ng-container>
            </nz-collapse>
          </div>

        </div>
      </div>
    </nz-card>
  </section>


  <section id="remarks" class="mt-8">
    <nz-card>
      <div class="mb-3">
        <h5>Remarks</h5>
      </div>
      <form nz-form [formGroup]="inspectionForm">
        <div formGroupName="remarks">
          <nz-form-item>
            <nz-form-control>
              <nz-textarea-count [nzMaxCharacterCount]="150">
                <textarea rows="6" nz-input formControlName="remark" PlaceHolder="Enter Notes here"></textarea>
              </nz-textarea-count>
            </nz-form-control>
          </nz-form-item>
        </div>
      </form>
    </nz-card>
  </section>

  <section id="buttons" class="mt-6">
    <nz-card>
      <div class="flex justify-end sm:justify-end">
        <a nz-popconfirm nzPopconfirmTitle="Are you sure you want to cancel this record? you will loose all data."
           nzPopconfirmPlacement="bottom" (nzOnConfirm)="confirm()" (nzOnCancel)="cancel()">
          <button class="outline-button mr-3" nz-button nzType="default">Cancel</button>
        </a>
        <a nz-popconfirm nzPopconfirmTitle="Are you sure you want to save, Saved Data is not editable"
           nzPopconfirmPlacement="bottom" (nzOnConfirm)="onSubmit()">
          <button nz-button nzType="primary" [disabled]="this.inspectionForm.invalid">Save Record</button>
        </a>
      </div>
    </nz-card>
  </section>
</div>
<div [ngClass]="loading ? 'block' : 'hidden'">
  <app-edit-view-skeleton-template></app-edit-view-skeleton-template>
</div>


<nz-modal [(nzVisible)]="isVisible" [nzTitle]="modalTitle" [nzContent]="modalContent" [nzFooter]="modalFooter"
          (nzOnCancel)="handleCancel()">
  <ng-template #modalTitle>
    <div class="flex justify-between">
      <div>
        <div class="badge" style="background-color: #F06A21">
          <span class="badge-number" *ngIf="modalStatus==='add'">{{ this.markerNumber }}</span>
          <span class="badge-number" *ngIf="modalStatus==='edit'">{{ this.tempNumber }}</span>
        </div>
      </div>
      <!--      add click animation-->
      <div class="flex items-center" style="margin-right:25px; cursor: pointer">
        <img src="assets/img/camera.png" alt="image" class="mr-3" (click)="triggerFileInput()">
        <p style="color:#F06A21" class="font-medium" (click)="triggerFileInput()">Take a Photo</p>
        <input type="file" id="fileInput" (change)="onFileSelected($event)" accept=".pdf,.docx,.jpg,.png" style="display: none;">
      </div>
    </div>
  </ng-template>

  <ng-template #modalContent>
    <div class="mb-2 mt-2">
      <p class="font-medium">Damage Type</p>
      <nz-select nzPlaceHolder="Select" [(ngModel)]="damageType" style="display: block">
        <nz-option nzValue="Scratch" nzLabel="Scratch"></nz-option>
        <nz-option nzValue="Dent" nzLabel="Dent"></nz-option>
        <nz-option nzValue="Broken" nzLabel="Broken"></nz-option>
        <nz-option nzValue="Cracked" nzLabel="Cracked"></nz-option>
        <nz-option nzValue="Missing" nzLabel="Missing"></nz-option>
        <nz-option nzValue="Stain" nzLabel="Stain"></nz-option>
        <nz-option nzValue="Smashed" nzLabel="Smashed"></nz-option>
      </nz-select>
    </div>
    <div class="mb-2">
      <p class="font-medium">Description</p>
      <textarea rows="3" [(ngModel)]="damageDesc" nz-input PlaceHolder="Enter Description"></textarea>
    </div>
    <div class="mb-2">
      <p class="font-medium">Attachments</p>

      <div class="flex flex-col items-center justify-center bg-slate-100 w-full h-32 xl:h-52 py-2">
        <div>
          <nz-upload [nzCustomRequest]="damageUpload" [nzShowUploadList]="false" [nzMultiple]="false">
            <button nz-button>
              <span nz-icon nzType="upload"></span>
              Click to Upload
            </button>
          </nz-upload>
        </div>
        <div>
          <p *ngIf="damageImgUploading" class="text-primary my-2">Uploading...</p>
        </div>
        <div class="mt-2 overflow-auto">
          <div *ngFor="let file of damageFiles; let i = index" class="flex justify-between items-center mx-3 gap-5">
            <a target="_blank" href="{{file.url}}">{{ file.name }}</a>
            <span nz-icon nzType="close-circle" nzTheme="outline" [nzTheme]="'twotone'" [nzTwotoneColor]="'#ff0000'"
                  class="cursor-pointer" nz-popconfirm
                  nzPopconfirmTitle="Are you sure you want to delete this attachment"
                  (nzOnConfirm)="confirmRemoveAttachment(i)"></span>
          </div>
        </div>
      </div>

      <!--      <nz-upload [nzCustomRequest]="damageUpload" [nzShowUploadList]="false" [nzMultiple]="false"-->
      <!--                 class="flex justify-center items-center bg-slate-100 w-full h-32 xl:h-48">-->
      <!--        <button nz-button>-->
      <!--          <span nz-icon nzType="upload"></span>-->
      <!--          Click to Upload-->
      <!--        </button>-->
      <!--      </nz-upload>-->
      <!--      <div *ngIf="damageImgUploading" class="flex justify-center items-center">-->
      <!--        <p class="text-primary">Uploading...</p>-->
      <!--      </div>-->
      <!--      <div *ngFor="let file of damageFiles; let i=index">-->
      <!--        <a class="" target="_blank" href="{{file.url}}">{{file.name}} <span nz-icon nzType="close" nz-popconfirm-->
      <!--                                                                            nzPopconfirmTitle="Are you sure you want to delete the attachment"-->
      <!--                                                                            nzPopconfirmPlacement="bottom"-->
      <!--                                                                            (nzOnConfirm)="confirmRemoveAttachment(i)"-->
      <!--                                                                            (nzOnCancel)="cancel()"-->
      <!--                                                                            nzTheme="outline"></span></a>-->
      <!--      </div>-->
    </div>
  </ng-template>

  <ng-template #modalFooter>
    <button nz-button class="outline-button" nzType="default" (click)="handleCancel()">Cancel</button>
    <button nz-button nzType="primary" [disabled]="this.damageDesc==='' || this.damageType==='' || damageImgUploading"
            *ngIf="this.modalStatus === 'add'" (click)="handleOk(this.tempMouseEvent)">Save
    </button>
    <button nz-button nzType="primary" [disabled]="this.damageDesc==='' || this.damageType==='' || damageImgUploading"
            *ngIf="this.modalStatus === 'edit'" (click)="updatePanel()">Update
    </button>
  </ng-template>
</nz-modal>


<nz-modal [(nzVisible)]="isVisibleCom" [nzContent]="modalContent2" [nzFooter]="modalFooter2"
          (nzOnCancel)="handleCancel2()">
  <ng-template #modalContent2>
    <h4 class="mb-3">Is Damage Fixed ?</h4>
    <p class="mb-1">Comment</p>
    <input nz-input type="text" [(ngModel)]="this.comment" placeholder="Comment">
  </ng-template>

  <ng-template #modalFooter2>
    <button nz-button nzType="default" (click)="handleCancel2()">Cancel</button>
    <button nz-button nzType="primary" (click)="handleOk2()">Confirm</button>
  </ng-template>
</nz-modal>
